<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Add report files</h4>

          <label class="col-form-label col-form-label-sm">{{ $t('Webportal.Customer') }}</label>
          <client-filter
            v-model="clientId"
            :multipleClientSelection="false"
            :propertySelection="false"
          />

          <report-file-properties v-model="reportFileProperties" :client-id="clientId" />

          <file-uploader
            ref="reportFileUploader"
            :value="reportFiles"
            accept="application/pdf, application/zip"
            :upload-url="reportFileUploadUrl"
            :additional-form-data="reportFileAdditionalFormData"
            :show-preview-link="false"
            :show-download-button="false"
            :disabled="!reportFileProperties.reportFileCategory"
            @is-busy-changed="isGeneralFileUploaderBusy = $event"
          />
        </div>

        <div class="card-footer">
          <button type="button" @click="$router.go(-1);" class="btn btn-secondary" :disabled="isGeneralFileUploaderBusy">
            <font-awesome-icon :icon="['far', 'arrow-left']" />
            {{ $t("Webportal.Back") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import ClientFilter from "@/components/ClientFilter";
import ReportFileProperties from "./ReportFileProperties";
import AuthenticationService from '@/services/AuthenticationService';

export default {
  name: "ReportFileImport",

  components: { FileUploader, ClientFilter, ReportFileProperties },

  data() {
    return {
      clientId: null,
      reportFileProperties: {},
      reportFiles: [],
      isGeneralFileUploaderBusy: false,
    };
  },

  computed: {
    reportFileUploadUrl() {
      return this.clientId
        ? process.env.BASE_URL + `api/reportfile/${this.clientId}/attachment`
        : null;
    },

    reportFileAdditionalFormData() {
      return [
          ['report-file-category-name', this.reportFileProperties.reportFileCategory],
          ['property-ids', this.reportFileProperties.propertyIds ? this.reportFileProperties.propertyIds.join("|") : ""],
          ['clientlocation-ids', this.reportFileProperties.clientLocationIds?.join()],
          ['is-visible', AuthenticationService.isMSMUser],
        ];
    },
  },
};
</script>

<style>
</style>